import React from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import PageHeading from './../../components/shared/PageHeading.component'
import { MDBContainer, MDBIcon, MDBCol, MDBRow } from 'mdbreact'
import AgentEandOManager from './../../components/agents/AgentEandOManager/AgentEandOManager.component'

const EoPolicyPage = (props) => {
  return (
    <DashboardLayout>
      <main className="mainSection" className="mainSection pb-5">
        <MDBContainer fluid className="mt-5">
          <PageHeading
            label="Agent E&O Policy"
            url={props?.match?.url}
            from={props?.location?.state?.from}
          />
        </MDBContainer>
        <MDBContainer className="pb-5">
          <MDBRow>
            <MDBCol>
              <div className="content-wrapper">
                <AgentEandOManager />
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </main>
    </DashboardLayout>
  )
}

export default EoPolicyPage
